
    import Vue from 'vue';

    export default Vue.extend({
        name: "MessageText",
        props: {
            isError: {
                type: Boolean,
                default: false,
                required: false
            },
            isInfo: {
                type: Boolean,
                default: false,
                required: false
            },
            message: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: false
            }
        },
        computed: {
            classes() {
                if (this.isInfo) {
                    return "message-info";
                }
                else if (this.isError) {
                    return "message-error";
                }
                else {
                    return "message-success";
                }
            }
        }    
    })
